
export const SET_ACCOUNT_BALANCE = 'SET_ACCOUNT_BALANCE';

export const setAccountBalance = (accountBalance) => {
    return dispatch => {
        dispatch({ type: SET_ACCOUNT_BALANCE, accountBalance: accountBalance });
    }
}
